import { render } from "./monitorplayWechat.vue?vue&type=template&id=b8f0f9a0&scoped=true&ts=true"
import script from "./monitorplayWechat.vue?vue&type=script&lang=ts"
export * from "./monitorplayWechat.vue?vue&type=script&lang=ts"

import "./monitorplayWechat.vue?vue&type=style&index=0&id=b8f0f9a0&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f0f9a0"]])

export default __exports__